import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-ng-template-settings',
    templateUrl: './ng-template-settings.component.html',
    styleUrls: ['./ng-template-settings.component.scss']
})
export class NgTemplateSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    exampleSettingValue: number;

    constructor() { }

    ngOnInit(): void {
        this.moduleManager.addSetting({
            name: 'exampleSetting',
            required: true, // only set if required
            onMissingValue: () => { // only set if required
                // update with your error message
                // e.g.: ctrl.showMissingExampleError = true;
                // then in your markup (this is just a simple example, please adapt to your needs):
                //  <span ng-show="$ctrl.showMissingExampleError">Example setting value must be set.</span>
            },
            // send your value to the moduleManager to be saved
            // saving is done when the user hits the apply button
            getValue: () => this.exampleSettingValue,
            onSettingLoaded: value => {
                this.exampleSettingValue = value;
                // onSettingsApplied() will be called in your [Template].js as well,
                //  passing a settings object with settings.exampleSetting containing the loaded value
            },
            // this is the value that will be returned if the setting has not been saved before
            defaultValue: 30
        });

        // tell module manager that you have finished adding your settings
        this.moduleManager.customSettingsAdded = true;
    }
}
